// extracted by mini-css-extract-plugin
export default {"box":"sec1_box__hC8Ht","devOps":"sec1_devOps__KKyA6","engineer":"sec1_engineer__Hu28c","imgLogo":"sec1_imgLogo__SgXtK"};